/**
 * Web Leaflet raster tiles.
 *
 * Use international OSM Carto (tile.openstreetmap.org) — the old map look.
 * OSM.de is the German style (bilingual labels, forest symbols, other
 * borders/roads), not Carto. OSM France is a greener fork.
 * No fallback to other styles (mixed colors look wrong). Retry the same
 * URL on tileerror; do not animate fitBounds on first view.
 *
 * @see https://operations.osmfoundation.org/policies/tiles/
 * @see https://wiki.openstreetmap.org/wiki/Raster_tile_providers
 */

export const OSM_RASTER_TILE_URL =
  import.meta.env.VITE_OSM_TILE_SERVER ||
  'https://tile.openstreetmap.org/{z}/{x}/{y}.png';

export const OSM_TILE_ATTRIBUTION =
  '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors';

export const ESRI_SATELLITE_TILE_URL =
  'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}';

export const ESRI_SATELLITE_ATTRIBUTION = '&copy; Esri';

export const MAX_TILE_RETRIES = 3;

const pendingReload = new WeakMap<HTMLImageElement, ReturnType<typeof setTimeout>>();

function scheduleTileSrc(tile: HTMLImageElement, src: string, delayMs: number): void {
  const previous = pendingReload.get(tile);
  if (previous !== undefined) {
    globalThis.clearTimeout(previous);
  }
  const handle = globalThis.setTimeout(() => {
    pendingReload.delete(tile);
    tile.src = '';
    tile.src = src;
  }, delayMs);
  pendingReload.set(tile, handle);
}

export function retryFailedLeafletTile(
  tile: HTMLImageElement,
  maxRetries = MAX_TILE_RETRIES
): void {
  const retryCount = Number(tile.dataset.tileRetry ?? '0');
  if (retryCount >= maxRetries) return;

  tile.dataset.tileRetry = String(retryCount + 1);
  scheduleTileSrc(tile, tile.src, 400 * (retryCount + 1));
}
